import { apiClient } from "../client";
import { API_ENDPOINTS } from "../endpoints";

export interface UserListParams {
  page?: number;
  limit?: number;
  search?: string;
  authProvider?: string;
}

export const userService = {
  getAll: (params: UserListParams = {}) => {
    const query = new URLSearchParams();
    if (params.page) query.set("page", String(params.page));
    if (params.limit) query.set("limit", String(params.limit));
    if (params.search) query.set("search", params.search);
    if (params.authProvider) query.set("authProvider", params.authProvider);
    const qs = query.toString();
    return apiClient.get(`${API_ENDPOINTS.USERS.LIST}${qs ? `?${qs}` : ""}`);
  },
  getById: (id: string) => apiClient.get(API_ENDPOINTS.USERS.DETAIL(id)),
  deleteUser: (id: number) => apiClient.delete(API_ENDPOINTS.USERS.DELETE(id)),
};
